import * as React from "react";

import "./template-creation-route.scss";

import {BlockWindowUnload}              from "@Common/react/block-window-unload";
import {cs}                             from "@Common/react/chain-services";
import {consumeContext, provideContext} from "@Common/react/context";
import {UseState}                       from "@Common/react/use-state";
import {CcApis3}                        from "@Common/tools/cc-integration/cc_apis/cc-apis-3";
import {mapBindingData}                 from "@Common/tools/cc-integration/cc-editor/map-binding-data";
import {Button}                         from "@Common/tools/cc-integration/ui/button/button";
import {isDevXd}                        from "@Common/ui-components/debug/is-dev";
import {AlertModal}                     from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";
import {ConfirmDialog2}                 from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog-2/confirm-dialog-2";
import {arrMapToO2}                     from "@Common/utils/objects";

import * as Constants from "../../../../../../template_admin/client/src/common/constants";
import {SubHeader}    from "../../../common/sub-header/sub-header";
import {Layout}       from "../../../layout/layout";

import {UserCreatedTemplateModal} from "../user-created-template-modal/user-created-template-modal";

import {PreviewCcView}        from "./preview-cc-view/preview-cc-view";
import {TemplateCreationView} from "./template-creation-view/template-creation-view";

export const TemplateCreationRoute = ({match}) => {
    const storedState = localStorage.getItem('templateCreationState');
    let dataProperties, data1, data2, mockData, preview, previewState, previewHighResUrls, template, toDbJsonPrep, updating, ccHostResponse, acknowledgements, filePath;
    if (storedState) {
        let parsedState = JSON.parse(storedState);
        if (parsedState.dataProperties) dataProperties = parsedState.dataProperties;
        if (parsedState.data1) data1 = parsedState.data1;
        if (parsedState.data2) data2 = parsedState.data2;
        if (parsedState.mockData) mockData = parsedState.mockData;
        if (parsedState.preview) preview = parsedState.preview;
        if (parsedState.previewState) previewState = parsedState.previewState;
        if (parsedState.previewHighResUrls) previewHighResUrls = parsedState.previewHighResUrls;
        if (parsedState.template) template = parsedState.template;
        if (parsedState.toDbJsonPrep) toDbJsonPrep = { value: parsedState.toDbJsonPrep };
        if (parsedState.updating) updating = parsedState.updating;
        if (parsedState.ccHostResponse) ccHostResponse = parsedState.ccHostResponse;
        if (parsedState.acknowledgements) acknowledgements = parsedState.acknowledgements;
        if (parsedState.filePath) filePath = parsedState.filePath;
    }
    return cs(
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("routerHistory"),
    ["preview", (_, next) => UseState({
        initValue: false,
        next,
    })],
    ["previewState", (_, next) => UseState({
        initValue: previewState,
        next,
    })],
    ["previewHighResUrls", (_, next) => UseState({
        initValue: previewHighResUrls,
        next,
    })],
    ["updating", (_, next) => UseState({
        defaultValue: {
            downloadPercent: 0,
        },
        next,
    })],
    ["ccApis", ({company}, next) => next(
            CcApis3({
                host: ccHostResponse.value.ccHost,
                headers: {
                    "authorization": "Basic " + window.btoa(`${Constants.CC_API_USERNAME}:${Constants.CC_API_PASSWORD}`),
                    "userguid": `company-${company.idCompany}`
                }
            })
    )],
    ["data1", (_, next) => UseState({
        initValue: data1.value,
        next,
    })],
    ["data2", (_, next) => UseState({
        initValue: data2.value,
        next,
    })],
    ["dataProperties", (_, next) => UseState({
        initValue: dataProperties.value,
        next,
    })],
    ({ccApis}, next) => provideContext({ccApis, ccHostResponse}, next),
    ["templateCreationView", ({apis, company, session, data1, data2, dataProperties}, next) => (
            TemplateCreationView({
                ccStateId: template.value?.idState,
                data1,
                data2,
                dataProperties,
                idmlPath: filePath,
                mockData,
                templateIds: [match.params.source_id ?? template.value?.sourceTemplateId],
                apis,
                company,
                session,
                next
            })
        )
    ],
    ["editingStateId", ({templateCreationView}, next) => UseState({
        initValue: templateCreationView.editingStateId,
        next,
    })],
    ["alertModal", ({}, next) => AlertModal({next})],
    ["templateModal", ({
        alertModal, apis, catSubStyle, ccApis, company, editingStateId, previewHighResUrls, previewState, routerHistory, templateCreationView
    }, next) => UserCreatedTemplateModal({
        key: template.value?.idPrimary ?? 0,
        onClick: async (updatedTemplate) => {
            let imageAssetIds = {}
            let saveEditingResponse;
            if( preview.value ) {
                if( previewState.value && Object.keys(previewState.value).length != 0 ) {
                    let uploadResult = await apis.next.userCreated.uploadImage( {urls: previewHighResUrls.value, idAssets: updatedTemplate.value.image && JSON.parse(updatedTemplate.value.image) } );
                    if( !uploadResult["errorMessage"] ) {
                        imageAssetIds = uploadResult;
                    }
                    else
                    {
                        await alertModal.show({message: "An error has occurred."});
                    }
                    await ccApis.deleteState(previewState.value);
                }
                await ccApis.deleteState(editingStateId.value);
            }
            else {
                saveEditingResponse = await templateCreationView.saveEditingState();

                if (!saveEditingResponse || !saveEditingResponse.stateId) {
                    await alertModal.show({message: "An error has occurred."});
                    return false;
                }
                let mockDataFormatted;
                if(!mockData?.loading && !mockDataFormatted){
                    mockDataFormatted = {};
                    mockData?.value.forEach((data)=>{
                        mockDataFormatted[data.name] = data.value ? JSON.parse( data.value ) : {}
                    });
                }

                let bindingResults = await mapBindingData({"xd": mockDataFormatted}, toDbJsonPrep.value.xdJson.templateBindingData,
                    toDbJsonPrep.value.xdJson.templateConfigurations, ccApis, null, null, toDbJsonPrep.value.ccJson,
                    ccApis.currentHost, null, null, null, null);

                let mergeData = [];
                if(bindingResults?.['surfaces'] ) {
                    for( const [surfaceName, surfaceObj] of Object.entries(bindingResults?.['surfaces']) ) {
                        for( const [name, value] of Object.entries(surfaceObj) ) {
                            if( value ) {
                                mergeData.push({
                                    name,
                                    type: ['inlineVariable', 'dropdown'].includes(toDbJsonPrep.value.xdJson.templateBindingData?.[surfaceName]?.[name]?.type) ? "text" : "image",
                                    value
                                });
                            }
                        }
                    }
                }

                let proofResults = await ccApis.getHighResProducts({
                    stateId: saveEditingResponse.stateId,
                    userId: `company-${company.idCompany}`,
                    surfaceCount: templateCreationView.sides.length,
                    rotations: templateCreationView.ccConfig.rotations,
                    format: ["jpg"],
                    mergeFields: mergeData
                });

                if( proofResults?.jpg ) {
                    let uploadResult = await apis.next.userCreated.uploadImage( {urls: proofResults.jpg, idAssets: updatedTemplate.value.image && JSON.parse(updatedTemplate.value.image) } );
                    if( !uploadResult["errorMessage"] ) {
                        imageAssetIds = uploadResult;
                    }
                    else {
                        await alertModal.show({message: "An error has occurred during thumbnail generation."});
                    }
                }
                else {
                    await alertModal.show({message: "An error has occurred during thumbnail generation."});
                }
                await ccApis.deleteState(saveEditingResponse.stateId);
            }

            let saved = await templateCreationView.save(templateCreationView.ccStateId);
            editingStateId.onChange("");
            previewState.onChange("");
            const result = await apis.next.userCreated.updateTemplate({
                updateFields: {
                    idPrimary: updatedTemplate.value.idPrimary,
                    name: updatedTemplate.value.name,
                    idCategory: updatedTemplate.value.idCategory,
                    active: updatedTemplate.value.active,
                    idState: templateCreationView.ccStateId ?? saved?.stateId,
                    sourceTemplateId: parseInt(match.params.source_id ?? template.value?.sourceTemplateId, 10),
                    ccConfig: JSON.stringify(toDbJsonPrep.value),
                    image: JSON.stringify(imageAssetIds)
                }
            });

            if (result?.errors || result?.errorMessage) {
                await alertModal.show({message: "An error has occurred."});
                return false;
            }
            else {
                await catSubStyle?.reload();
                //redirect to private or public based on category assignment selected
                routerHistory.replace(`/manage-templates/${(updatedTemplate.value.idCategory ? "public" : "private")}`);
            }
        },
        onClose: () => true,
        next,
    })],
    ["confirmDialog", ({}, next) => ConfirmDialog2({next})],
    ({apis, confirmDialog, data1, data2, dataProperties, templateCreationView, templateModal, preview, updating, previewState, previewHighResUrls}) => {
        let builtProperties = {
            frames: {}
        };
        let xdJson = {
            templateBindingData: {},
            templateConfigurations: {}
        }

        if(templateCreationView.items) {
            if(match?.params?.source_id) {
                if( templateCreationView.editingStateId == null ) {
                    templateCreationView.saveEditingState();
                } else {
                    const updatedAcknowledgements = {
                        ...(acknowledgements ? JSON.parse(acknowledgements): {}),
                        ccVersion: templateCreationView.ccVersion,
                        filePath: filePath
                    };
                    apis.next.userCreated.updateTemplate({
                        updateFields: {
                            idPrimary: template.value?.idPrimary,
                            idState: templateCreationView.editingStateId,
                            acknowledgements: JSON.stringify(updatedAcknowledgements),
                        }
                    });
                }
            }
            templateCreationView.sides.forEach((surface)=>{
                builtProperties["frames"][surface] = arrMapToO2(
                    templateCreationView.items.filter((item)=>item.parentContainer.parentComponent.name == surface),
                    (i) => removeEmptyFields( dataProperties.value?.[i.parentContainer.parentComponent.name]?.[i.name] ),
                    (i) => i.name
                );
                xdJson["templateBindingData"][surface] = arrMapToO2(
                    templateCreationView.items.filter((item)=>item.parentContainer.parentComponent.name == surface),
                    (i) => removeEmptyFields( data2.value?.[surface]?.[i.name] ),
                    (i) => i.name
                );
                xdJson["templateConfigurations"][surface] =  arrMapToO2(
                    templateCreationView.items.filter((item)=>item.parentContainer.parentComponent.name == surface),
                    (i) => removeEmptyFields( data1.value?.[surface]?.[i.name] ),
                    (i) => i.name
                )
            })
        }

        if(JSON.stringify(toDbJsonPrep.value) !== JSON.stringify({ "ccJson": builtProperties, "xdJson": xdJson })) {
            toDbJsonPrep = {value: {
                "ccJson": builtProperties,
                "xdJson": xdJson
            }};
        }

        return (
            <Layout className="template-creation-route-s5v"
                navBlock={{
                    block: async () => !await confirmDialog.show({
                        actionName: "exit",
                        message: "Changes will be lost.",
                        buttons: {
                            confirmLabel: "Confirm",
                        },
                    })
                }}
            >
                {BlockWindowUnload({})}
                {preview.value ? <div>
                    <SubHeader
                        backLink={{}}
                        title="Preview Customized Template"
                    />
                    {PreviewCcView({
                        editingStateId: templateCreationView.editingStateId,
                        mockData,
                        preview,
                        previewState,
                        previewHighResUrls,
                        template: template.value,
                        templateModal,
                        templateIds: [parseInt(match.params.source_id ?? template.value?.sourceTemplateId)],
                        userCreatedCcConfig: toDbJsonPrep.value,
                        advEditMode: false,
                        update: (updateObj) => {
                            if(updateObj?.previewState) {
                                previewState.onChange(updateObj?.previewState);
                            }
                            if(updateObj?.previewHighResUrls) {
                                previewHighResUrls.onChange(updateObj?.previewHighResUrls);
                            }
                        }
                    })}
                </div>
                : <></>}
                <div style={{display:preview.value?"none":"inline-block"}}>
                    <SubHeader
                        backLink={{}}
                        title="Customize Template"
                    />
                    {templateCreationView.render()}
                    {isDevXd() && (
                        cs(
                            ["show", (_, next) => UseState({
                                initValue: false,
                                next,
                            })],
                            ({show}) => (<>
                                <a
                                    onClick={() => show.onChange(!show.value)}
                                    className="show"
                                    xd-qa-type="link"
                                    xd-qa-name="show"
                                >
                                    Show/Hide
                                </a>
                                {show.value && <div>"To store to DB:"<pre>{JSON.stringify(toDbJsonPrep.value, null, 4).replace(/\\\\/g, "\\")}</pre> </div>}
                            </>)
                        )
                    )}

                    <div className="buttonLine">
                        <div className="buttonContainer">
                            <Button
                                buttonText="Preview Template"
                                xdQaName="Preview Template"
                                downloadProgressPercent={updating.value.downloadPercent}
                                onClick={async () => {
                                    await templateCreationView.saveEditingState();

                                    // remove download percent after another second to ensure that 100% status is displayed to the user
                                    await setTimeout(() => updating.onChange({...updating.value, downloadPercent: 0}), 1000);

                                    preview.onChange(!preview.value);
                                }}
                            />
                        </div>
                        <div className="buttonContainer">
                            <Button
                                buttonText="Save Without Preview"
                                xdQaName="Save Without Preview"
                                onClick={ async () => {
                                    templateModal.show();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Layout>
        );
    },
)};

const removeEmptyFields = ( data ) => {
    if(typeof(data) != 'undefined'){
        Object.keys( data ).forEach((key) =>
            ( data[key] == null || data[key] == '' || data[key].length == 0 ) && delete data[key]
        );
    }
    return { ...data };
};